<div class="d-flex flex-column flex-fill dx-card">
  <div class="d-flex mt-3 ms-3">
    <dx-form [formData]="filter" style="max-width: 150px">
      <dxi-form-item dataField="startDate" editorType="dxDateBox"></dxi-form-item>
      <dxi-form-item dataField="endDate" editorType="dxDateBox"></dxi-form-item>
    </dx-form>
    <div class="d-flex flex-column ms-3 mt-3">
      <button class="btn btn-secondary" (click)="toggleShowPreviousWeek()">
        {{ showPreviousWeek ? 'This Week' : 'Previous Week' }}
      </button>
      <button class="btn btn-primary mt-2" (click)="getData()">Search</button>
    </div>
    @if (!!tonsDumped) {
      <div class="tons-dumped-table">
        <table class="table">
          <thead>
            <h4 style="text-align: center;">Dumpster Tons By Type Summary</h4>
            <tr>
              <th>Type</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            @for (category of tonsDumped.categories; track category) {
              <tr>
                <td class="col-xs-2 table-little-padding">{{ category.name }}</td>
                <td class="col-xs-1 table-little-padding total-right-align">{{ category.tons | number }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    <div class="d-flex flex-column ms-4">
      <h4 style="text-align: center;">Jobs Using Trailers</h4>
      <h5>{{ jobsUsingTrailer }}</h5>
    </div>
  </div>
  <div class="flex-row flex-fill d-flex">
    <div class="d-flex flex-fill flex-column col-sm-5 pt-3 pb-2 px-2">
      <h4 class="mx-2 my-0">Revenue</h4>
      <dx-data-grid
        #revenueGrid
        keyExpr="id"
        class="flex-fill d-flex flex-column"
        height="350px"
        [dataSource]="revenue"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        [columnAutoWidth]="false"
        >
        <dxi-data-grid-column dataField="id" caption="JobId" width="50"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="rentalId" caption="RentalId" width="50"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="customer" width="200"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="action" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="dumpster" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="completed" dataType="date" format="M/d/yyyy" width="90"></dxi-data-grid-column>
        <dxi-data-grid-column
          dataField="estimatedRevenue"
          caption="Est.Rev."
          [format]="{ type: 'currency', precision: 2 }"
          width="90"
        ></dxi-data-grid-column>
        <dxi-data-grid-column dataField="weight" width="90"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="salesPerson" width="90"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="range" width="90"></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>

        <dxo-data-grid-summary>
          <dxi-data-grid-total-item column="estimatedRevenue" summaryType="sum" displayFormat="{0}" [valueFormat]="{ precision: 2 }">
          </dxi-data-grid-total-item>
        </dxo-data-grid-summary>

        <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="report-revenue-grid"></dxo-data-grid-state-storing>
        <div *dxTemplate="let data of 'toolbarButtons'">
          <button
            class="btn btn-sm btn-danger me-1 mb-2"
            (click)="createRevenueLines(revenueGrid.instance.getSelectedRowsData())"
            [disabled]="revenueGrid.instance.getSelectedRowsData().length === 0"
            >
            Create Revenue Lines
          </button>
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (revenue) {
            <span class="me-3">
              <strong>{{ revenueGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
    <div class="d-flex flex-fill flex-column col-sm-5 pt-3 pb-2 px-2">
      <!-- <h4 *ngFor="let category of tonsDumped?.categories" class="mx-2 my-0">{{ category.name }}: {{ category.tons }}</h4> -->
      <h4 class="mx-2 my-0">Tons Dumped</h4>
      <dx-data-grid
        #tonsGrid
        keyExpr="id"
        class="flex-fill d-flex flex-column"
        height="350px"
        [dataSource]="tonsDumped?.jobs"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        [columnAutoWidth]="false"
        >
        <dxi-data-grid-column dataField="completed" dataType="date" format="M/d/yyyy" width="90"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="id" caption="Job #" width="50"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="tons" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="jobType" width="90"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="action" width="90"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="driver" width="125"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="dumpster" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="billAs" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="customer" width="200"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="displayAddress" caption="Service Address" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="dumpAddress" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>

        <dxo-data-grid-summary>
          <dxi-data-grid-total-item column="tons" summaryType="sum" [valueFormat]="{ precision: 2 }"> </dxi-data-grid-total-item>
        </dxo-data-grid-summary>

        <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="report-tons-grid"></dxo-data-grid-state-storing>
        <div *dxTemplate="let data of 'toolbarButtons'"></div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (tonsDumped?.jobs) {
            <span class="me-3">
              <strong>{{ tonsGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
    <div class="d-flex flex-fill flex-column col-sm-2 pt-3 pb-2 px-2">
      <h4 class="mx-2 my-0">Job Count: {{ jobCounts?.totalCount }}</h4>
      <dx-data-grid
        #jobsGrid
        keyExpr="id"
        class="flex-fill d-flex flex-column"
        height="350px"
        [dataSource]="jobCounts?.jobCounts"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        [columnAutoWidth]="false"
        >
        <dxi-data-grid-column dataField="jobType" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="action" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="count" width="90"></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>

        <dxo-data-grid-summary>
          <dxi-data-grid-total-item column="count" summaryType="sum"> </dxi-data-grid-total-item>
        </dxo-data-grid-summary>

        <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="report-jobs-grid"></dxo-data-grid-state-storing>
        <div *dxTemplate="let data of 'toolbarButtons'"></div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (jobCounts?.jobCounts) {
            <span class="me-3">
              <strong>{{ jobsGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
